import { TemplatePage } from './types';

const ecommercePage: TemplatePage = {
  header: {
    color: '#D7C3F2',
    icon: 'images/video-templates/ecommerce.jpg',
    title: 'E-commerce and Retail Video Templates Collection',
    title_meta: '50+ Free and Customizable E-commerce Video Templates',
    description_meta:
      'Use the power of video to showcase your products. With Wave.video’s 50+ e-commerce templates, your ' +
      'online store is a center of attraction for consumers.',
    description:
      'Explore the collection of video templates tailored for e-commerce and retail business. Whatever products ' +
      'you want to promote, they deserve to be demonstrated in the best way possible. '
  },
  footer: {
    category: 'E-commerce',
    description:
      'Wave.video features a wide range of ready-to-use video templates that you can customize to your particular ' +
      'use case in minutes. Use your own footage or browse the stock library, change the colors and fonts, add ' +
      'logos and CTAs. Your videos won’t go unnoticed!'
  },
  content: [
    {
      type: 'templates',
      title: 'E-commerce and Retail Video Templates',
      search: { category: '/Industries/eCommerce' }
    },
    { type: 'stocks', title: 'ecommerce', search: { name: 'ecommerce' } },
    { type: 'calendar' }
  ]
};

export default ecommercePage;
